import clsx from 'clsx';

import Text from '@commons/components/Text';
import Flex from '@commons/containers/Flex';
import { useFormattedDate } from '@commons/hooks/useFormattedDate';
import { Link } from '@commons/i18n/navigation';

import type { PressReleaseNodeProps } from '.';
import styles from './Card.module.scss';

/**
 * Press Release node component for the Card display type.
 */

const PressReleaseNodeCard = (props: PressReleaseNodeProps) => {
  const { title, description, date, link } = props;

  const formattedDate = useFormattedDate(date);

  return (
    <Link href={link.url}>
      <Flex
        gap="xs"
        border="left"
        paddingLeft="xs"
        direction="column"
        className={clsx(styles.card, 'h-100')}
      >
        <Text as="p" level="label-md" transform="uppercase" marginBottom="none">
          {formattedDate}
        </Text>
        <Text level="h4" marginBottom="none" className={styles.title}>
          {title}
        </Text>
        <Text level="body-sm" marginBottom="xs" color="grey-7">
          {description}
        </Text>
      </Flex>
    </Link>
  );
};

export default PressReleaseNodeCard;
